/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestEventDto } from '../../models/harvest-event-dto';

export interface DeleteEvent$Params {
  eventId: number;
  harvestId: number;
}

export function deleteEvent(http: HttpClient, rootUrl: string, params: DeleteEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<HarvestEventDto>> {
  const rb = new RequestBuilder(rootUrl, deleteEvent.PATH, 'delete');
  if (params) {
    rb.path('eventId', params.eventId, {});
    rb.path('harvestId', params.harvestId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HarvestEventDto>;
    })
  );
}

deleteEvent.PATH = '/api/harvests/{harvestId}/event/{eventId}';
